/** Slugify a site name to a URL-safe slug — MUST match the api-shim's
 *  `_aruba_slug` ('Jedi AI Office' -> 'jedi-ai-office') so the slug
 *  round-trips. Used for both Aruba sites and CLI host groups. */
export function arubaSlug(name: string): string {
  const out: string[] = [];
  let prevDash = false;
  for (const ch of (name || "").toLowerCase()) {
    if (/[a-z0-9]/.test(ch)) {
      out.push(ch);
      prevDash = false;
    } else if (!prevDash) {
      out.push("-");
      prevDash = true;
    }
  }
  return out.join("").replace(/^-+|-+$/g, "") || "site";
}
